var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFamily = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 13.5        A13.5 13.5 0 1 1 0 13.5        A13.5 13.5 0 1 1 27 13.5 Z",
    fill: "#FDE9EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.45, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9043 20.1239C14.129 21.2742 15.4706 22.2242 16.9854 22.9734C17.7968 23.374 18.7593 23.3376 19.5372 22.8761C20.8494 22.0978 21.9915 21.1608 23.0955 20.1239C25.4357 17.9252 26.8004 14.8998 26.89 11.7089L26.9945 7.98842C27.0065 7.55555 26.995 6.60136 26.995 6.60136C26.4713 6.51135 25.942 6.44528 25.4132 6.37972C23.7774 6.17577 22.1486 5.97339 20.7193 5.06446L19.7003 4.41672C19.2675 4.14412 18.7713 4 18.2653 4C17.7594 4 17.2631 4.14412 16.8303 4.41672L15.8543 5.03741C14.22 6.07588 12.2285 6.27255 10.301 6.46297C9.86428 6.50615 9.43055 6.54933 9.00534 6.60136C9.00534 6.60136 8.99333 7.56127 9.00534 8.00038L9.10989 11.7089C9.19944 14.8998 10.5636 17.9252 12.9043 20.1239V20.1239ZM10.0008 7.53838C10.0008 7.70487 10.0023 7.85835 10.0058 7.97021L10.1099 11.6787C10.1914 14.5767 11.4306 17.3373 13.5747 19.3518C14.7313 20.4376 15.9924 21.3299 17.4151 22.0333C17.6713 22.159 17.9526 22.219 18.2357 22.2084C18.5187 22.1979 18.7952 22.1169 19.042 21.9724C20.2701 21.244 21.3526 20.359 22.4252 19.3518C24.5693 17.3373 25.8084 14.5772 25.89 11.6787L25.9945 7.95772C25.9975 7.8417 25.9995 7.67781 25.9995 7.503C25.7654 7.47178 25.5273 7.44213 25.2842 7.41143L25.2571 7.40831C24.7014 7.34349 24.1473 7.26455 23.5953 7.17158C22.4727 6.97388 21.2981 6.65183 20.1976 5.95258L19.1785 5.30431C18.9029 5.13156 18.5871 5.04028 18.2653 5.04028C17.9435 5.04028 17.6278 5.13156 17.3521 5.30431L16.3761 5.925C15.2155 6.66223 13.9349 7.01186 12.7007 7.21841C11.9353 7.3464 11.1109 7.42808 10.339 7.50508L10.0008 7.5389V7.53838Z",
    fill: "#EF3545"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9902 18.4245V8.80859H18.9902V18.4245H16.9902Z",
    fill: "#EF3545"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4912 14.6837H13.4912V12.5469H22.4912V14.6837Z",
    fill: "#EF3545"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFamily);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "App/static/media/family.118998e6fd57b76fc996eb6a8a220331.svg";